module.exports = __webpack_public_path__ + "static/media/CeraPro-Black.7ddfca28.ttf";